const parseHtml = htmlString => {
  const parser = new DOMParser();
  return parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
};

const defaultDivider = {
  show: true,
  maxWidth: 200,
  height: 1,
  backgroundColor: '#E0E0E0',
  align: 'center',
};

export const extractDividerPrimary = htmlString => {
  const doc = parseHtml(htmlString);
  const result = {
    ...defaultDivider,
  };

  const dividerPrimaryEl = doc.querySelector('[data-attribute="divider-primary"]');
  if (dividerPrimaryEl) {
    result.show = dividerPrimaryEl.getAttribute('data-show') !== 'false';
  }

  const dividerPrimaryLineEl = doc.querySelector('[data-attribute="divider-primary-line"]');
  if (dividerPrimaryLineEl) {
    result.backgroundColor = dividerPrimaryLineEl.getAttribute('data-background') || result.backgroundColor;
    result.height = Number(dividerPrimaryLineEl.getAttribute('data-height')) || result.height;
    result.align = dividerPrimaryLineEl.getAttribute('data-align') || result.align;
    result.maxWidth = Number(dividerPrimaryLineEl.getAttribute('data-max-width')) || result.maxWidth;
  }

  return result;
};

export const updateDividerPrimary = (wrapel, updatedData) => {
  const show = !!updatedData.show;
  if (wrapel) {
    wrapel.setAttribute('data-show', show ? 'true' : 'false');
    wrapel.style.display = show ? 'block' : 'none';
  }
  const dividerPrimaryLineEl = wrapel.querySelector('[data-attribute="divider-primary-line"]');
  if (dividerPrimaryLineEl) {
    const margin =
      updatedData.align === 'center' ? '0 auto' : updatedData.align === 'left' ? '0 auto 0 0' : '0 0 0 auto';
    dividerPrimaryLineEl.setAttribute('data-background', updatedData.backgroundColor);
    dividerPrimaryLineEl.setAttribute('data-height', updatedData.height);
    dividerPrimaryLineEl.setAttribute('data-align', updatedData.align);
    dividerPrimaryLineEl.setAttribute('data-max-width', updatedData.maxWidth);
    dividerPrimaryLineEl.style.backgroundColor = updatedData.backgroundColor;
    dividerPrimaryLineEl.style.height = `${updatedData.height}px`;
    dividerPrimaryLineEl.style.margin = margin;
    dividerPrimaryLineEl.style.maxWidth = `${updatedData.maxWidth}px`;
  }
  return wrapel.outerHTML.trim();
};
